import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-invoice-not-found-dialog',
  templateUrl: './invoice-not-found-dialog.component.html',
  styleUrls: ['./invoice-not-found-dialog.component.scss']
})
export class InvoiceNotFoundDialogComponent {

  errorMsg: string;
  errorTitle: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.error && data.error.code === '403') {
      this.errorTitle = 'Access Denied';
      this.errorMsg = 'Insufficient permissions to view this invoice.';
    } else {
      this.errorTitle = 'Invalid or non-Revenue PRO';
      this.errorMsg = 'No invoice data was found for this PRO. Please check FBDS or Bill Details.';
    }
  }
}
